<template>
    <div id="info-alliances">
        <!--=====================================-->
        <!--=        Brand Area Start       	=-->
        <!--=====================================-->
        <section class="section mb--80">
            <div class="container">
                <div class="heading-light-left">
                    <h5 class="black bold text-center">Una cooperación de:</h5>
                </div>
                <div class="align-items-center justify-content-center row">
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500">
                        <div class="brand-grid">
                            <img :src="`${logoBase}femsa.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="100">
                        <div class="brand-grid">
                            <img :src="`${logoBase}coop-alemania.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200">
                        <div class="brand-grid">
                            <img :src="`${logoBase}giz.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300">
                        <div class="brand-grid">
                            <img :src="`${logoBase}developpp.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-2 col-6" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400">
                        <div class="brand-grid">
                            <img :src="`${logoBase}redgirasol.png`" alt="Brand">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--=====================================-->
        <!--=        Blog Area Start       	    =-->
        <!--=====================================-->
        <section class="section mb--50" data-sal="slide-up" data-sal-duration="800">
            <div class="container">
                <div class="row row-40 justify-content-center">
                    <div class="col-lg-9">
                        <div class="single-blog single-blog-video">
                            <div class="single-blog-content blog-grid blog-thumb-slide">
                                <div class="post-thumbnail shadow-box">
                                    <img :src="videoBanner" alt="Blog">
                                    <div class="popup-video">
                                        <a href="https://www.youtube.com/watch?v=ybs-9AIoVhM" class="play-btn popup-youtube"><i class="fas fa-play"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name:"InfoAlliances",
        data: () => ({
            logoBase: "https://cdn.redgirasol.com/nuevo_portal/emerge/logos/logo-",
            videoBanner: "https://cdn.redgirasol.com/nuevo_portal/emerge/banners/04-banner-video.png"
        }),
        mounted() {
            this.magnificPopupActivation();
        },
        methods: {
            magnificPopupActivation: function() {
                let yPopup = $('.popup-youtube');
                if (yPopup.length) {
                    yPopup.magnificPopup({
                        disableOn: 300,
                        type: 'iframe',
                        mainClass: 'mfp-fade',
                        removalDelay: 160,
                        preloader: false,
                        fixedContentPos: false
                    });
                }
            },
        }
    }
</script>

<style>
.brand-grid img {
    filter: none;
    opacity: 1;
}

.shadow-box {
    border-radius: 3rem;
}

/**
 * Simple fade transition,
 */
 .mfp-fade.mfp-bg {
	opacity: 0;
	-webkit-transition: all 0.15s ease-out; 
	-moz-transition: all 0.15s ease-out; 
	transition: all 0.15s ease-out;
}
.mfp-fade.mfp-bg.mfp-ready {
	opacity: 0.8;
}
.mfp-fade.mfp-bg.mfp-removing {
	opacity: 0;
}

.mfp-fade.mfp-wrap .mfp-content {
	opacity: 0;
	-webkit-transition: all 0.15s ease-out; 
	-moz-transition: all 0.15s ease-out; 
	transition: all 0.15s ease-out;
}
.mfp-fade.mfp-wrap.mfp-ready .mfp-content {
	opacity: 1;
}
.mfp-fade.mfp-wrap.mfp-removing .mfp-content {
	opacity: 0;
}
</style>